module.exports = __webpack_public_path__ + "static/img/gpt13.3af0a4a3.png";